// @flow
import styled from 'styled-components';
import Grid from 'styled-components-grid';
import {
  pt, pb, mx
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';

import { StyledCoverMaxWidth as StyledCoverMaxWidthOriginal } from '@components/Wrappers';

export const StyledCoverMaxWidth = styled(StyledCoverMaxWidthOriginal)`
  ${pt(3)}
`;

export const StyledItem = styled(Grid.Unit)`
  ${pb(4.5)}
  ${breakpoint('desktop')`
    ${pb(0)}
    img{
      max-width:100%;
    }
  `};
  ${breakpoint('mobile', 'desktop')`
    ${mx(2)}
    min-width:280px;
    height:100%;
    img{
      min-width:280px;
      max-width:100%;
      height:100%;
    }
  `}
  &:last-of-type {
    ${pb(0)}
  }
`;
